module.exports = __webpack_public_path__ + "img/1289545645.83f8ea40.jpg";